import * as v from "valibot";
import { baseVals, defineRecordSchema, defineValidation } from "../../common/validation.common";
import { UserTypeEnum } from "../../data/enums";

export namespace UserValidation {
    export const Record = defineValidation(
        defineRecordSchema({
            filters: v.object({
                userType: v.optional(v.picklist(UserTypeEnum.values)),
            }),
        }),
    );

    export const Login = defineValidation(
        v.object({
            username: baseVals.string(),
            password: baseVals.string(),
            longSession: v.optional(v.boolean()),
        }),
    );

    export const Update = defineValidation(
        v.object({
            email: v.exactOptional(baseVals.email()),
            username: v.exactOptional(baseVals.username()),
            avatar: v.exactOptional(baseVals.string()),
        }),
    );

    export const UpdatePassword = defineValidation(
        v.object({
            oldPassword: baseVals.string(),
            newPassword: baseVals.password(),
        }),
    );

    export const UpdateDeviceToken = defineValidation(
        v.object({
            deviceToken: baseVals.string(),
        }),
    );

    export const RecreateAvatar = defineValidation(
        v.object({
            name: baseVals.string(),
        }),
    );
}
